import { defaultTrainSDK } from '@train-protocol/sdk';
import { defaultTrainAuth } from '@train-protocol/auth';
import { AztecHTLCPublicClient, AztecHTLCWalletClient } from './client/index';
import { deriveKeyFromAztecWallet } from './login/index';
export { AztecHTLCPublicClient, AztecHTLCWalletClient } from './client/index';
export { deriveKeyFromAztecWallet } from './login/index';
export function registerAztecSdk(sdk, auth) {
    const s = sdk ?? defaultTrainSDK;
    const a = auth ?? defaultTrainAuth;
    s.registerHTLCPublicClient('aztec', (config) => new AztecHTLCPublicClient(config));
    s.registerHTLCWalletClient('aztec', (config) => new AztecHTLCWalletClient(config));
    a.registerWalletSign('aztec', async (config) => {
        return deriveKeyFromAztecWallet(config.wallet, config.address);
    });
}
